//Shea Signature Communities Carousel

//Shea Signature Communities listing Carousel
function initCommunityListCarousel(){
    const communityFigures = $('.community-figures');

    communityFigures.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: "600",
        infinite: true,
        useTransform: false,
        mobileFirst: true,
        fade: true,
        lazyLoad: 'ondemand',
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Play Previous Video"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Play Next Video"></button>'
    });
}


const withSlickInit = async () => {

    await import("slick-carousel");

    initCommunityListCarousel();
};

window.initCommunityListCarousel = withSlickInit;